import React, { useContext } from 'react';
import './TreatmentBanner.scss';
import { LanguageContext } from '../../context/LanguageContext';

const TreatmentBanner = () => {
    const { currentLang } = useContext(LanguageContext);

    const content = {
        tr: {
            title: "Tedavilerimiz",
            description: "Mona Klinik olarak, ağız ve diş sağlığınız için en güncel tedavi yöntemlerini sunuyoruz. Uzman kadromuz ve modern teknolojimizle, size özel çözümler üretiyoruz."
        },
        en: {
            title: "Our Treatments",
            description: "At Mona Clinic, we offer the most up-to-date treatment methods for your oral and dental health. With our expert staff and modern technology, we create customized solutions for you."
        }
    };

    return (
        <section className="treatment-banner">
            <div className="banner-inner">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            {/* Banner Content */}
                            <div className="treatment-banner-content">
                                <h1 className="treatment-banner-title">
                                    {content[currentLang].title}
                                </h1>
                                <p className="treatment-banner-description">
                                    {content[currentLang].description}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TreatmentBanner; 